import '@atlaskit/css-reset';
import { getHistory } from '@atlassian/ptc-common';
import { AggRelayEnvironmentProvider } from '@townsquare/relay-utils/agg-environment';
import StandaloneApp from '@atlassian/standalone-directory';
import React from 'react';
import { AppContext } from '@townsquare/app-context';
import { AuthCheck } from '@townsquare/auth';
import { Bootstrap } from './bootstrap/Bootstrap';
import { StatSigInit } from './bootstrap/StatSigInit';
const history = getHistory();
const App = () => {
  return <AuthCheck>
			<AppContext.Provider value={{
      app: 'teams-isolated'
    }}>
				<AggRelayEnvironmentProvider>
					<Bootstrap>
						{({
            orgId,
            cloudId,
            accountId
          }) => <StatSigInit orgId={orgId} cloudId={cloudId} accountId={accountId}>
								<StandaloneApp appName="teams-isolated" history={history} />
							</StatSigInit>}
					</Bootstrap>
				</AggRelayEnvironmentProvider>
			</AppContext.Provider>
		</AuthCheck>;
};
export { App };